import React from "react";
import { Button } from "../../components/Button";
import { X, CheckCircle, XCircle } from "lucide-react";
import { SettingsPanelProps } from "./types";

export const SettingsPanel: React.FC<SettingsPanelProps> = ({
  onClose,
  successMessage,
  error,
  children,
}) => {
  return (
    <div className="bc-theme-editor-sidepanel">
      <div className="bc-theme-editor-sidepanel-header">
        <h2 className="bc-theme-editor-sidepanel-title">Theme Settings</h2>
        <Button
          variant="icon"
          size="sm"
          onClick={onClose}
          aria-label="Close settings"
        >
          <X size={16} />
        </Button>
      </div>

      <div className="bc-theme-editor-sidepanel-content">
        {/* Messages */}
        {successMessage && (
          <div className="bc-theme-editor-message bc-theme-editor-message-success">
            <CheckCircle size={14} /> {successMessage}
          </div>
        )}
        {error && (
          <div className="bc-theme-editor-message bc-theme-editor-message-error">
            <XCircle size={14} /> {error}
          </div>
        )}

        {children}
      </div>
    </div>
  );
};

